/**
 * Цвета piano roll (сетка, клавиши, подписи) — единственный источник правды.
 * Раньше настраивались через Settings (цвета + высота) и читали CSS-переменные
 * темы; теперь это фиксированные константы светлой схемы (см. app.css) и не
 * зависят от `prefers-color-scheme`.
 */

export type PianoRollColors = {
  gridStrong: string;
  gridMed: string;
  gridFaint: string;
  gridSub: string;
  keyWhite: string;
  keyBlack: string;
  keyBorder: string;
  keyLabel: string;
};

export const PIANO_ROLL_COLORS: Readonly<PianoRollColors> = Object.freeze({
  gridStrong: "rgba(20, 30, 60, 0.4)",
  gridMed: "rgba(20, 30, 60, 0.16)",
  gridFaint: "rgba(20, 30, 60, 0.1)",
  gridSub: "rgba(20, 30, 60, 0.06)",
  keyWhite: "rgba(20, 30, 60, 0.04)",
  keyBlack: "rgba(20, 30, 60, 0.1)",
  keyBorder: "rgba(20, 30, 60, 0.18)",
  keyLabel: "rgba(20, 30, 60, 0.6)",
});
